<template>
  <Dialog
    header="Inactivity Warning"
    v-model:visible="isVisible"
    :style="{ width: '30vw' }"
    :modal="true"
    :closable="false"
  >
    <p class="m-0">
      You will be logged out in {{ countdown }} seconds due to inactivity.
    </p>
    <template #footer>
      <Button label="Stay Logged In" icon="pi pi-check" @click="stayLoggedIn" />
    </template>
  </Dialog>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      countdown: 5,
      timeoutId: null,
      logoutTimer: null,
    };
  },
  mounted() {
    this.startInactivityTimer();
    document.addEventListener('mousemove', this.resetTimer);
    document.addEventListener('keydown', this.resetTimer);
    document.addEventListener('scroll', this.resetTimer);
  },
  beforeUnmount() {
    document.removeEventListener('mousemove', this.resetTimer);
    document.removeEventListener('keydown', this.resetTimer);
    document.removeEventListener('scroll', this.resetTimer);
    clearTimeout(this.timeoutId);
    clearInterval(this.logoutTimer);
  },
  methods: {
    startInactivityTimer() {
      this.timeoutId = setTimeout(() => {
        this.showLogoutWarning();
      }, 60 * 60 * 1000); // 60 minutes
    },
    resetTimer() {
      clearTimeout(this.timeoutId);
      this.countdown = 5;
      this.isVisible = false; 
      this.startInactivityTimer();
    },
    showLogoutWarning() {
      this.isVisible = true;
      this.countdown = 5; // Reset countdown
      this.startCountdown();
    },
    startCountdown() {
      this.logoutTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.logoutTimer);
          this.logout();
        }
      }, 1000);
    },
    stayLoggedIn() {
      this.isVisible = false;
      this.resetTimer(); 
    },
    logout() {
      localStorage.removeItem('aid');
      localStorage.removeItem('refresh');
      this.$router.push('/login');
    },
  },
};
</script>

<style>
/* Add any styles for the dialog if needed */
</style>
